import React, {Component} from "react";
import {Card, Form, Button, InputGroup} from "react-bootstrap";
import SimpleScrollbar from "../custom_scrollbars/SimpleScrollbar";
import InlineSVG from "react-inlinesvg";
import searchIcon from "../../../assets/svg/actions/icn-search.svg";
import classes from "classnames";

class MembersSection extends Component {

    onSearchChange = () => {
        if(this.props.onSearchChange)
            this.props.onSearchChange();
    }

    onMemberClick = (event, key) => {
        var {name, memberClick} = this.props;
        if(memberClick)
            memberClick(event, key, name);
    }

    memberHeaderExtraContent = () => {
        var { memberHeaderExtraContent } = this.props;
        if(memberHeaderExtraContent)
            return (
                <this.props.memberHeaderExtraContent />
            );
    }

    render() {

        var memberList = this.props.memberList.map((member) => {
            return (
                <Card className={["member", member.active ? 'active' : ''].join(' ')} key={member.key} onClick={(event) => this.onMemberClick(event, member.key)}>
                    <img src={member.avatar} alt="Avatar image"/>
                    <div className="member-info">
                        <h3>{member.name}</h3>
                        <p className={classes(member.status)}>
                            {
                                member.status == 'test'
                                    ? "No conversation to display. Please add participant to start coversation"
                                    : member.excerpt
                            }
                        </p>
                    </div>
                    {
                        member.date_of_publish
                            ? (<span className="date-of-publish">{member.date_of_publish}</span>)
                            : null
                    }
                </Card>
            )
        });

        return (
            <section className="members-section">
                {this.memberHeaderExtraContent()}
                <div className="search">
                    <InputGroup className="input-group-white-lg">
                        <Form.Control name="text" placeholder={ this.props.memberSearchPlaceholder ?? '' } className="input input-white input-lg" onChange={this.onSearchChange} />
                        <InputGroup.Append>
                            <InputGroup.Text>
                                <i><InlineSVG src={searchIcon}/></i>
                            </InputGroup.Text>
                        </InputGroup.Append>
                    </InputGroup>
                </div>
                <SimpleScrollbar className={`members-list-scroll ${this.props.memberButtonText ? "has-footer" : null }`} maxHeight={this.props.maxHeight}>
                    <div className="members-list">
                        {memberList}
                    </div>
                </SimpleScrollbar>
                {
                    this.props.memberButtonText ? (
                            <div className="button-container">
                                <Button variant="primary" className="btn-block btn-md" onClick={this.props.memberButtonClick}>{this.props.memberButtonText}</Button>
                            </div>
                    ) : null
                }
            </section>
        )
    }
};

export default MembersSection;
